import { ReactNode } from 'react';

import Typography from '@components/Typography';

import { Container, LabelWrapper } from './style';

type CardProps = {
  label: string;
  children: ReactNode;
};

const Card = ({ label, children }: CardProps) => {
  return (
    <Container>
      {label ? (
        <LabelWrapper>
          <Typography variant='Title4' weight='Bold' color='D400'>
            {label}
          </Typography>
        </LabelWrapper>
      ) : null}
      {children}
    </Container>
  );
};

export default Card;
